import React from "react";
import styles from "./styles.module.scss";
import { TrashIcon } from "../../assets";

export default function Empty() {
  return (
    <>
      <div className={styles.emptyState}>
        <div className={styles.emptyStateContent}>
          <div className={styles.emptyStateMessage}>Data not found</div>
          <div className={styles.emptyStateHelp}>
            <TrashIcon fill="#b2b3bd" />
          </div>
        </div>
      </div>
    </>
  );
}
